<script>
import { mapActions, mapGetters } from 'vuex'
import { ORGANIZATION_CUSTOMER_TYPE_CODE } from '@/const'
import { TYPES as CUSTOMER_CNT_TYPES } from './store'
import { TYPES as CNT_ORG_TYPES } from '../../../organization-contact/store'
import { ROUTES as CUSTOMER_ORG_ROUTES } from '../../../organization/organization/customer-organization/router'
import { ROUTES as CUSTOMER_CONTACT_ROUTES } from '../../../router'

import ContactCreateMixin from '../../../components/contact/mixins/ContactCreateMixin'

export default {
  name: 'CustomerContactCreate',
  mixins: [ContactCreateMixin],
  data () {
    return {
      orgId: this.$route.params.id,
      id: this.$route.params.cntId,
      orgType: ORGANIZATION_CUSTOMER_TYPE_CODE,
      CUSTOMER_ORG_ROUTES,
      CUSTOMER_CONTACT_ROUTES,
      ORGANIZATION_CUSTOMER_TYPE_CODE,
      showDuplicatedContactModal: false
    }
  },
  computed: {
    ...mapGetters({
      ...CUSTOMER_CNT_TYPES.GENERIC.organization.customercontact.DETAIL.GETTERS
    })
  },
  methods: {
    ...mapActions({
      ...CUSTOMER_CNT_TYPES.GENERIC.organization.customercontact.DETAIL.ACTIONS,
      getContactList: CUSTOMER_CNT_TYPES.GENERIC.organization.customercontact.LIST.ACTIONS.getList,
      createOrganizationContact: CNT_ORG_TYPES.GENERIC.organization.organizationcontact.DETAIL.ACTIONS.create
    }),
    onCancel () {
      this.$emit('close-form')
    }
  }
}
</script>
